<template>
  <div id="app">
    <router-view />
    <loading-indicator />
    <modal-actions />
    <modal-messages />
  </div>
</template>

<script>
import LoadingIndicator from '@/components/LoadingIndicator'
import ModalActions from '@/components/ModalActions'
import ModalMessages from '@/components/ModalMessages'

export default {
  name: 'App',
  components: {
    LoadingIndicator,
    ModalActions,
    ModalMessages
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue